import React from "react";
import { TextField, Typography, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import "@ckeditor/ckeditor5-build-classic/build/translations/fa";
import CheckBox from "@jumbo/Dashboards/Banner/CheckBox";
import CustomDatePicker from "@jumbo/Dashboards/Gallery/components/datePicker";
import CustomSelect from "@jumbo/Dashboards/Banner/CustomSelect";
import { useSelector, useDispatch } from "react-redux";
import { setFormSettings } from "redux/actions/FormBuilder";
import { dateFormat } from "@jumbo/utils/shamsiStandardFormat";

const useStyles = makeStyles((theme) => ({
  textFieldLabel: {
    color: theme.palette.primary.main,
    marginBottom: "16px",
    fontWeight: "bold",
  },
  formControl: {
    width: "100%",
  },
}));

const LimitSettings = () => {
  const classes = useStyles();

  const { formSettings } = useSelector(({ formBuilder }) => formBuilder);
  const dispatch = useDispatch();

  const {
    formLimit,
    limitCount,
    hasDateLimit,
    startDate,
    endDate,
    accessList,
    accessListTopic,
    accessListType,
    family,
    blackAccessList,
    blackAccessListTopic,
    blackAccessListType,
    blackAccessListError,
    removable,
  } = formSettings;

  return (
    <>
      <Grid item xs={12}>
        <CheckBox
          name={"countLimit"}
          title={"تعداد محدود"}
          value={formLimit}
          handleChange={() =>
            dispatch(
              setFormSettings({ ...formSettings, formLimit: !formLimit })
            )
          }
        />
      </Grid>

      {formLimit && (
        <Grid item xs={12} md={7}>
          <Typography className={classes.textFieldLabel}>تعداد</Typography>
          <TextField
            id="limit"
            label="تعداد"
            variant="outlined"
            type="number"
            className={classes.formControl}
            value={limitCount}
            onChange={(e) =>
              dispatch(
                setFormSettings({ ...formSettings, limitCount: e.target.value })
              )
            }
            onWheel={(e) => e.target.blur()}
          />
        </Grid>
      )}

      <Grid item xs={12}>
        <CheckBox
          name={"timeLimit"}
          title={"زمان محدود"}
          value={hasDateLimit}
          handleChange={() =>
            dispatch(
              setFormSettings({ ...formSettings, hasDateLimit: !hasDateLimit })
            )
          }
        />
      </Grid>

      {hasDateLimit && (
        <>
          <Grid item xs={12} md={7} style={{ marginTop: "16px" }}>
            <CustomDatePicker
              title={"زمان آغاز"}
              value={startDate || dateFormat}
              updateWithVal={(val) =>
                dispatch(
                  setFormSettings({
                    ...formSettings,
                    startDate: val,
                  })
                )
              }
            />
          </Grid>

          <Grid item xs={12} md={7} style={{ marginTop: "16px" }}>
            <CustomDatePicker
              title={"زمان پایان"}
              value={endDate || dateFormat}
              updateWithVal={(val) =>
                dispatch(
                  setFormSettings({
                    ...formSettings,
                    endDate: val,
                  })
                )
              }
            />
          </Grid>
        </>
      )}

      <Grid item xs={12}>
        <CheckBox
          name={"accessLimit"}
          title={"لیست سفید دسترسی"}
          value={accessList}
          handleChange={() =>
            dispatch(
              setFormSettings({
                ...formSettings,
                accessList: !accessList,
              })
            )
          }
        />
      </Grid>

      {accessList && (
        <>
          <Grid item xs={12} md={7}>
            <Typography className={classes.textFieldLabel}>
              محدودیت دسترسی
            </Typography>
            <TextField
              id="access limit"
              label="محدودیت دسترسی"
              variant="outlined"
              className={classes.formControl}
              value={accessListTopic}
              onChange={(e) =>
                dispatch(
                  setFormSettings({
                    ...formSettings,
                    accessListTopic: e.target.value,
                  })
                )
              }
              onWheel={(e) => e.target.blur()}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomSelect
              title={"نوع دسترسی"}
              value={accessListType}
              handleChange={(val) =>
                dispatch(
                  setFormSettings({
                    ...formSettings,
                    accessListType: val,
                  })
                )
              }
              options={[
                { value: "CodeMeli", text: "کد ملی" },
                { value: "CodePersoneli", text: "کد پرسنلی" },
              ]}
            />
          </Grid>
        </>
      )}

      <Grid item xs={12}>
        <CheckBox
          name={"accessLimit"}
          title={"لیست سیاه دسترسی"}
          value={blackAccessList}
          handleChange={() =>
            dispatch(
              setFormSettings({
                ...formSettings,
                blackAccessList: !blackAccessList,
              })
            )
          }
        />
      </Grid>

      {blackAccessList && (
        <>
          <Grid item xs={12} md={7}>
            <Typography className={classes.textFieldLabel}>
              محدودیت دسترسی
            </Typography>
            <TextField
              id="access limit"
              label="محدودیت دسترسی"
              variant="outlined"
              className={classes.formControl}
              value={blackAccessListTopic}
              onChange={(e) =>
                dispatch(
                  setFormSettings({
                    ...formSettings,
                    blackAccessListTopic: e.target.value,
                  })
                )
              }
              onWheel={(e) => e.target.blur()}
            />
          </Grid>
          <Grid item xs={12} md={7}>
            <Typography className={classes.textFieldLabel}>
              متن خطای دسترسی
            </Typography>
            <TextField
              id="access limit"
              label="متن خطای دسترسی"
              variant="outlined"
              className={classes.formControl}
              value={blackAccessListError}
              onChange={(e) =>
                dispatch(
                  setFormSettings({
                    ...formSettings,
                    blackAccessListError: e.target.value,
                  })
                )
              }
              onWheel={(e) => e.target.blur()}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomSelect
              title={"نوع دسترسی"}
              value={blackAccessListType}
              handleChange={(val) =>
                dispatch(
                  setFormSettings({
                    ...formSettings,
                    blackAccessListType: val,
                  })
                )
              }
              options={[
                { value: "CodeMeli", text: "کد ملی" },
                { value: "CodePersoneli", text: "کد پرسنلی" },
              ]}
            />
          </Grid>
        </>
      )}

      <Grid item xs={12}>
        <CheckBox
          name={"familyLimit"}
          title={"کد پرسنلی یکتا"}
          value={family}
          handleChange={() =>
            dispatch(
              setFormSettings({
                ...formSettings,
                family: !family,
              })
            )
          }
        />
      </Grid>

      <Grid item xs={12}>
        <CheckBox
          name={"removableLimit"}
          title={"قابلیت حذف ورودی توسط کاربر"}
          value={removable}
          handleChange={() =>
            dispatch(
              setFormSettings({
                ...formSettings,
                removable: !removable,
              })
            )
          }
        />
      </Grid>
    </>
  );
};

export default LimitSettings;
